/**
 * Scroll Progress Bar
 */
const scrollProgress = () => {
  const $progress = document.querySelector('.js-scrollProgress')

  if ($progress) {
    window.onload = () => {
      const docHeight = document.documentElement.clientHeight
      const mainHeight = document.querySelector('main').clientHeight
      // const snsHeight = document.querySelector('.c-sns').clientHeight
      const asideHeight = document.querySelector('.c-aside').clientHeight
      // console.log('document: ' + docHeight)
      // console.log('content: ' + mainHeight)

      // const items = document.querySelector('.c-items')
      let content;

      // if (items) {
      //   const itemsHeight = items.clientHeight
      //   content = mainHeight - (docHeight + snsHeight + itemsHeight)
      // } else {
      //   content = mainHeight - (docHeight + snsHeight)
      // }

      content = mainHeight - (docHeight + asideHeight)

      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        // console.log(scrollY);
        const scroll = Math.floor(scrollY / content * 100)
        // console.log(scroll)
        $progress.style.width = scroll + '%'
      })
    }
  }

}

export { scrollProgress };
